import { useQuery } from '@tanstack/react-query';

import {
  CompaniesService,
  ManufacturerListsService,
  SearchService,
} from '@/generated/api';

import { ManufacturerContactActions } from '../components/ContactButton';

export function useManufacturerLists(enabled: boolean = true) {
  return useQuery({
    enabled,
    queryKey: ['manufacturerLists'],
    queryFn:
      ManufacturerListsService.manufacturerListsControllerGetManufacturerLists,
  });
}

export function useManufacturerList(listId: number) {
  return useQuery({
    queryKey: ['manufacturerList', { listId }],
    queryFn: () =>
      ManufacturerListsService.manufacturerListsControllerGetManufacturersListById(
        listId,
      ),
    enabled: !!listId,
  });
}

export function useManufacturerPage(uuid: string) {
  return useQuery({
    queryKey: ['manufacturerPage', { uuid }],
    queryFn: () => CompaniesService.companyControllerGetProfile(uuid),
    enabled: !!uuid,
  });
}

export function useManufacturerSearch({
  uuid,
  triggeredBy,
}: {
  uuid: string;
  triggeredBy?: string;
}) {
  return useQuery({
    queryKey: ['manufacturerSearch', { uuid, triggeredBy }],
    queryFn: () =>
      SearchService.manufacturerSearchControllerGetManufacturerSearchData(uuid),
    enabled: !!uuid && uuid.length > 0,
    initialData: null,
  });
}

export function useManufacturerContactDetails({
  encodedUrl,
  enabled,
  contactType,
}: {
  encodedUrl: string;
  enabled: boolean;
  contactType: ManufacturerContactActions;
}) {
  return useQuery({
    queryKey: ['manufacturerContactDetails', { encodedUrl, contactType }],
    queryFn: () =>
      SearchService.manufacturerSearchControllerGetManufacturerContactDetails(
        encodedUrl,
        contactType,
      ),
    enabled,
  });
}
